import { render, staticRenderFns } from "./smallCard.vue?vue&type=template&id=6c94dccb"
import script from "./smallCard.vue?vue&type=script&lang=js"
export * from "./smallCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Kirbyimage: require('/opt/build/repo/frontend/components/kirbyimage.vue').default})
